export default __webpack_public_path__ + "static/media/ts.5f09d2ac.png";